<template>
    <div class="favorite_button" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction">
        <div class="favorite">
            <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31 27" style="enable-background:new 0 0 31 27;" xml:space="preserve">
                <path @click.stop="click" class="favorite_path" :class="{clicked: item_is_in_plan_board}" d="M13.246,0.544c0,0-9.414,6.34-12.547,8.444
	C0.594,9.06,0.5,9.149,0.5,9.287v18.901c0,0.172,0.128,0.313,0.285,0.313h25.429c0.158,0,0.286-0.141,0.286-0.313V9.348
	c0-0.137-0.093-0.288-0.199-0.359c-3.063-2.057-12.547-8.444-12.547-8.444C13.589,0.485,13.411,0.485,13.246,0.544"/>
            </svg>
        </div>
        <div class="hover_sukikamo pc" v-if="hoverFlag && !clicked"><img src="../assets/images/hover_sukikamo_planboard.svg" alt="マイホームできたカモに追加する?"></div>
    </div>
</template>

<script>
    import AddSukikamoList from './AddSukikamoList'
    import Ajax from '../assets/js/Ajax'

    export default {
        name: "FavoriteButton",
        components: { AddSukikamoList },
        props: {
            photo_data: Object,
            list_id: String
        },
        data: () => ({
            clicked: false,
            hoverFlag: false,
            is_loading: false,
        }),
        computed: {
            item_is_in_plan_board: _this => _this.photo_data.plan_board_list.includes(_this.list_id)
        },
        methods: {
            async click() {
                if ( this.is_loading ) return;
                this.is_loading = true;

                if ( this.item_is_in_plan_board ) {
                    Ajax.removePlanBoardItem(this.list_id, this.photo_data.photo_id);
                    const plan_board_list = this.photo_data.plan_board_list.filter(id => id !== this.list_id);
                    this.$set(this.photo_data, 'plan_board_list', plan_board_list)
                } else {
                    Ajax.addPlanBoardItem(this.list_id, this.photo_data.photo_id);
                    const plan_board_list = [this.list_id, ...this.photo_data.plan_board_list];
                    this.$set(this.photo_data, 'plan_board_list', plan_board_list)
                }

                this.is_loading = false;
            },
            mouseOverAction(){
                this.hoverFlag = true
            },
            mouseLeaveAction(){
                this.hoverFlag = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .favorite_path{
        fill-rule:evenodd;
        clip-rule:evenodd;
        fill:#FFFFFF;
        fill-opacity:0.85;
        stroke:#816E66;
        stroke-miterlimit:10;
        &:hover{
            cursor: pointer;
            opacity: 0.8;
        }
        &.clicked{
            fill:#E68A8A;
            fill-opacity:1;
        }
    }

    .favorite_button{
        position: relative;
        svg{
            width: 24px;
            height: 24px;
            vertical-align: middle;
        }
        .hover_sukikamo {
            position: absolute;
            top: -127px;
            right: -84px;
            width: 161px;
        }
        .sukikamo_list{
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 100%);
        }
    }
</style>
